class BzHeaderNav extends HTMLElement {
  connectedCallback() {
    this.triggers = Array.from(this.querySelectorAll('[data-bz-nav-trigger]'));
    this.panel = this.querySelector('[data-bz-nav-panel]');
    this.openTimer = 0;
    this.closeTimer = 0;
    this.pendingOpenTrigger = null;

    this.addEventListener('pointerover', (event) => this.#handlePointerOver(event));
    this.addEventListener('pointerout', (event) => this.#handlePointerOut(event));
    this.addEventListener('focusout', (event) => {
      if (!this.contains(event.relatedTarget)) this.#close();
    });
    this.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') this.#close();
    });

    this.triggers.forEach((trigger) => {
      trigger.addEventListener('focus', () => this.#open(trigger));
      trigger.addEventListener('click', () => {
        this.#open(trigger);
      });
    });

    this.querySelectorAll('.bz-header-nav__link:not([data-bz-nav-trigger])').forEach((link) => {
      link.addEventListener('focus', () => this.#close());
    });
  }

  #handlePointerOver(event) {
    const trigger = event.target.closest('[data-bz-nav-trigger]');
    if (trigger) {
      this.#scheduleOpen(trigger);
      return;
    }
    if (this.panel && this.panel.contains(event.target)) {
      this.#cancelClose();
      return;
    }
    this.#scheduleClose();
  }

  #handlePointerOut(event) {
    if (event.relatedTarget && this.contains(event.relatedTarget)) return;
    this.#cancelOpen();
    this.#scheduleClose();
  }

  #open(trigger) {
    this.#cancelOpen();
    this.#cancelClose();
    const id = trigger.dataset.bzNavTrigger;
    this.triggers.forEach((item) => {
      const active = item === trigger;
      item.classList.toggle('is-active', active);
      if (item.getAttribute('aria-haspopup') === 'true') {
        item.setAttribute('aria-expanded', active ? 'true' : 'false');
      }
    });

    this.querySelectorAll('[data-bz-nav-pane]').forEach((pane) => {
      pane.hidden = pane.dataset.bzNavPane !== id;
    });

    this.classList.add('is-open');
    if (this.panel) this.panel.hidden = false;
  }

  #close() {
    this.#cancelOpen();
    this.#cancelClose();
    this.classList.remove('is-open');
    this.triggers.forEach((item) => {
      item.classList.remove('is-active');
      if (item.getAttribute('aria-haspopup') === 'true') {
        item.setAttribute('aria-expanded', 'false');
      }
    });
    if (this.panel) this.panel.hidden = true;
  }

  #scheduleOpen(trigger) {
    if (trigger === this.pendingOpenTrigger) return;
    if (trigger.classList.contains('is-active')) {
      this.#cancelOpen();
      this.#cancelClose();
      return;
    }
    this.#cancelClose();
    this.#cancelOpen();
    this.pendingOpenTrigger = trigger;
    this.openTimer = window.setTimeout(() => {
      this.pendingOpenTrigger = null;
      this.#open(trigger);
    }, 200);
  }

  #cancelOpen() {
    window.clearTimeout(this.openTimer);
    this.pendingOpenTrigger = null;
  }

  #scheduleClose() {
    this.#cancelOpen();
    this.#cancelClose();
    this.closeTimer = window.setTimeout(() => this.#close(), 200);
  }

  #cancelClose() {
    window.clearTimeout(this.closeTimer);
  }
}

class BzHeaderNavMobile extends HTMLElement {
  connectedCallback() {
    this.screens = Array.from(this.querySelectorAll('[data-bz-nav-screen]'));
    this.querySelectorAll('[data-bz-nav-open]').forEach((button) => {
      button.addEventListener('click', () => this.#show(button.dataset.bzNavOpen));
    });
    this.querySelectorAll('[data-bz-nav-back]').forEach((button) => {
      button.addEventListener('click', () => this.#show(button.dataset.bzNavBack));
    });
    this.querySelectorAll('[data-bz-nav-close]').forEach((button) => {
      button.addEventListener('click', () => {
        const details = this.closest('details');
        if (details) details.open = false;
      });
    });
    this.closest('details')?.addEventListener('toggle', (event) => {
      if (!event.target.open) this.#show('root');
    });
  }

  #show(id) {
    this.screens.forEach((screen) => {
      screen.classList.toggle('is-active', screen.dataset.bzNavScreen === id);
    });
  }
}

if (!customElements.get('bz-header-nav')) {
  customElements.define('bz-header-nav', BzHeaderNav);
}

if (!customElements.get('bz-header-nav-mobile')) {
  customElements.define('bz-header-nav-mobile', BzHeaderNavMobile);
}
